import {Caster} from './caster';
import {InternalObjectPropertyMap} from "../basic-entity-interface/mapping-internal";
import {Type} from '@angular/core';

/*
 * Copyright (c) 2019. Nedaware SL
 */

/**
 * Nedaware S.L.
 * @author David Campos Rodríguez <david.campos.r96@gmail.com>
 */
export class ObjectCaster<T> implements Caster<T, object> {
    constructor(private _model: Type<any>,
                private _properties: InternalObjectPropertyMap[]) {
    }

    fromModel(modelValue: T | null): object | null {
        const obj = {};
        for (const prop of this._properties) {
            if (prop.apiBehavior.write) {
                obj[prop.key] = this._castProp(prop, modelValue[prop.modelKey], 'from');
            }
        }
        return obj;
    }

    private _castProp(prop: InternalObjectPropertyMap, value: any, fromOrTo: 'from' | 'to') {
        if (value instanceof Array) {
            if (prop.array) {
                return value.map(subValue => this._castProp(prop, subValue, fromOrTo));
            } else {
                throw new Error('Array value for non value property ' + prop.modelKey);
            }
        } else {
            return prop.caster ?
                (fromOrTo === 'from' ? prop.caster.fromModel(value) : prop.caster.toModel(value)) :
                value;
        }
    }

    toModel(apiValue: object | null): T | null {
        const obj: T = new this._model();
        for (const prop of this._properties) {
            if (prop.apiBehavior.read) {
                obj[prop.modelKey] = prop.caster ?
                    prop.caster.toModel(apiValue[prop.key]) :
                    apiValue[prop.key];
            }
        }
        return obj;
    }
}
